import { REHYDRATE } from 'redux-persist'

import { Action } from 'src/redux/action'
import { BaseRoute } from 'src/routes/BaseRoute'
import { AccessLevel } from 'src/routes/Route'
import { openRoute } from 'src/redux/actions/routes'
import { StateWithoutRoute } from 'src/redux/reducers'
import { doesNotHaveAccessToPrivateRoutes } from 'src/routes/utilities'

export default (
  route: BaseRoute = BaseRoute(),
  action: Action,
  state: StateWithoutRoute,
): BaseRoute => {
  switch (action.type) {
    case openRoute.type:
      return action.route
    case REHYDRATE:
      return action.key === 'account' &&
        action.payload &&
        ((action.payload.isLoggedIn &&
          BaseRoute.accessLevel(route) === AccessLevel.PRIVATE &&
          doesNotHaveAccessToPrivateRoutes(action.payload, undefined)) ||
          (!action.payload.isLoggedIn &&
            BaseRoute.accessLevel(route) > AccessLevel.PUBLIC))
        ? BaseRoute()
        : route
    default:
      return BaseRoute.reducer(route, action, state) || BaseRoute()
  }
}
